import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import "./_asset-block.scss"

const AssetBlock = props => {
  const { t } = useTranslation()

  const domainUrl = props.domainUrl

  const langs = useMemo(
    () => Object.keys(props.asset.langs || {}),
    [props.asset]
  )

  const label = useMemo(() => {
    let lang = (process.env.GATSBY_SITE_LANG || "").toLowerCase().split("_")[0]

    const asset = props.asset || {}
    const x = asset.langs[lang] || asset.langs["en"] || asset.langs[Object.keys(asset.langs)[0]] || {};
    return x.label || ""
  }, [props.asset])

  const url = useMemo(() => {
    let lang = (process.env.GATSBY_SITE_LANG || "").toLowerCase().split("_")[0]

    const asset = props.asset || {}
    const x = asset.langs[lang] || asset.langs["en"] || asset.langs[Object.keys(asset.langs)[0]] || {};
    return x.url || ""
  }, [props.asset])

  const ext = useMemo(() => {
    let lang = (process.env.GATSBY_SITE_LANG || "").toLowerCase().split("_")[0]

    const asset = props.asset || {}
    const x = asset.langs[lang] || asset.langs["en"] || asset.langs[Object.keys(asset.langs)[0]] || {};
    return x.ext ?? "???"
  }, [props.asset])

  const size = useMemo(() => {
    const units = ["B", "KB", "MB", "GB", "TB"]

    let lang = (process.env.GATSBY_SITE_LANG || "").toLowerCase().split("_")[0]

    const asset = props.asset || {}
    const x = asset.langs[lang] || asset.langs["en"] || asset.langs[Object.keys(asset.langs)[0]] || {};
    let size = x.size || 0
    let index = 0
    while (size > 1024 && index < units.length) {
      size = size / 1024.0
      index++
    }
    size = Math.trunc(size * 100) / 100
    return `${size} ${units[index]}`
  }, [props.asset])

  const downloadFile = (url, filename) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = filename
        a.click()
      })
  }

  return (
    <div className="d-flex flex-row py-3 asset-block align-items-center">
      <div className="flex-grow-0 flex-shrink-0 px-3">
        <svg width="24" height="31" viewBox="0 0 24 31" fill="none">
          <path
            d="M2.76947 29.7906C1.94 29.7906 1.26758 29.1182 1.26758 28.2887V2.75653C1.26758 1.92706 1.94 1.25464 2.76947 1.25464H14.1625C14.5608 1.25464 14.9428 1.41287 15.2245 1.69453L21.8542 8.32421C22.1358 8.60587 22.2941 8.98788 22.2941 9.38621V28.2887C22.2941 29.1182 21.6217 29.7906 20.7922 29.7906H2.76947Z"
            stroke="#005FB6"
            strokeWidth="2.25284"
          />
        </svg>
      </div>
      <div className="flex-grow-1">
        <div className="asset-block__label">{label}</div>
        <div className="asset-block__sublabel">
          {ext !== 'LINK' ? ext + ' - ' + size : ext}
        </div>
      </div>
      <div className="flex-grow-0 flex-shrink-0">
        {langs.map((lang, index) => {
          if (ext === "xml") {
            return (
              <a
                href="#"
                className="asset-block__lang-link"
                rel="nofollow"
                target="_self"
                key={index}
                onClick={e => {
                  e.preventDefault()
                  downloadFile(
                    props.asset.langs[lang].url,
                    props.asset.langs[lang].url.replace(
                      domainUrl,
                      ""
                    )
                  )
                }}
              >
                {lang}
              </a>
            )
          } else {
            return (
              <a
                href={props.asset.langs[lang].url}
                className="asset-block__lang-link"
                rel="nofollow"
                target={ ext.toLowerCase() === 'pdf' ? "_blank" : "_self" }
                key={index}
              >
                {lang}
              </a>
            )
          }
        })}
        <a
          href={url}
          rel="nofollow"
          className={ 'ext-' + ext.toLowerCase() + ' asset-block__icon-link' }
          target={ ext.toLowerCase() === 'pdf' ? "_blank" : "_self" }
        >
          <svg width="21" height="22" viewBox="0 0 21 22" fill="none">
            <path
              d="M14.0089 7.57129L10.5992 11.2726L7.38867 7.57129"
              stroke="#005FB6"
              strokeWidth="1.29014"
              strokeLinecap="square"
            />
            <path
              d="M10.6992 10.6667V4.00439"
              stroke="#005FB6"
              strokeWidth="1.29014"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
            <path
              d="M4.31836 13.2471V16.2754H17.0373V13.2471"
              stroke="#005FB6"
              strokeWidth="1.29014"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  )
}

export default AssetBlock
